//
//
//
//
//
//
//
//
//
//
//
//

import NotificationsItem from "./NotificationsItem";
export default {
  components: {
    NotificationsItem
  },
  props: {
    notifications: {
      type: Array,
      required: true,
    }
  },

}
